import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card, CardBody, Col, Row, Badge,
} from 'reactstrap';
import renderSelectField from '../../../shared/components/form/Select';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import ModalForm from '../../../shared/components/form/Modal';
import StampExamForm from './StampExamForm';

import Confirm from '../../../shared/components/Confirm';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import TextBox from '../../../shared/components/form/TextBox';
import DataTable from '../../../shared/components/DataTable';
import TooltipItem from '../../../shared/components/TooltipItem';
import validate from './validate';
import {
  Calificaciones,
  InstanciaExamen,
  EstadoExamen,
} from '../../../constants/enums';
import { dateFormat, dateDDMMYYFormat } from '../../../helpers/dateFormat';

import {
  stampExam,
  openExam,
  downloadAcademicStatusStudent,
  confirmExam,
} from '../../../redux/actions/examActions';

class ExamForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFilterChanges: PropTypes.func.isRequired,
    onSubjectChanges: PropTypes.func.isRequired,
    handleDeleteInscription: PropTypes.func.isRequired,
    handleActualizarNotasProfesor: PropTypes.func.isRequired,
    handleChangeText: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    id: PropTypes.number,
    cantidadReclamosPendientes: PropTypes.number,
    carreras: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    profesores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    materias: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    periodosExamen: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    instanciasExamen: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    periodosLectivos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    inscriptos: PropTypes.arrayOf(PropTypes.shape({})),
    history: PropTypes.shape({}).isRequired,
    nroActa: PropTypes.string,
    notasObservaciones: PropTypes.string,
    fecha: PropTypes.string.isRequired,
    fechaLimiteInscripcion: PropTypes.string.isRequired,
    fechaInicioReclamo: PropTypes.string,
    fechaFinReclamo: PropTypes.string,
    carrera: PropTypes.shape({}),
    periodo: PropTypes.shape({}),
    periodoLectivo: PropTypes.shape({}),
    materia: PropTypes.shape({}),
    profesor: PropTypes.shape({ value: PropTypes.number }),
    interventor: PropTypes.shape({}),
    interventorAuxiliar: PropTypes.shape({}),
    estado: PropTypes.shape({}),
  };

  static defaultProps = {
    id: 0,
    cantidadReclamosPendientes: 0,
    submitting: false,
    nroActa: '',
    notasObservaciones: '',
    fechaInicioReclamo: null,
    fechaFinReclamo: null,
    periodoLectivo: {},
    estado: {},
    periodo: {},
    interventorAuxiliar: {},
    interventor: {},
    profesor: {},
    materia: {},
    carrera: {},
    inscriptos: [],
  }


  constructor(props) {
    super(props);
    this.editExamInscription = this.editExamInscription.bind(this);
    this.addExamInscription = this.addExamInscription.bind(this);
    this.deleteExamInscription = this.deleteExamInscription.bind(this);

    this.state = {
      loading: false,
      currentUser: JSON.parse(localStorage.getItem('currentUser')) || {},
      inscriptos: props.inscriptos,
      stampModal: false,
      stampModeProfessor: false,
      stampExamData: {
        id: 0,
        materia: '',
        fecha: '',
        fechaInicioReclamo: '',
        fechaFinReclamo: '',
      },
    };

    this.inputStyle = (row, key = '') => {
      let color = 'greenyellow';

      if (row.esInconsistente) {
        const value = row[key];

        if (key === 'porcentajeAsistencia' && value !== row.asistenciaMateria) {
          color = 'red';
        }

        if (key === 'porcentajePP' && value !== row.ppMateria) {
          color = 'red';
        }
      }

      return {
        fontSize: '18px',
        width: '80px',
        height: '30px',
        color,
        textAlign: 'center',
        fontWeight: 'bold',
        // backgroundColor: '#232329',
      };
    };

    this.scoreInputStyle = {
      fontSize: '20px',
      height: '30px',
      color: 'cyan',
      textAlign: 'center',
      fontWeight: 'bold',
      // backgroundColor: '#232329',
    };

    this.columns = ({ canEdit, addButton }) => [
      /* {
        key: 'numeroLegajo',
        name: '# Legajo',
        width: '80px',
        search: false,
        type: 'number',
      }, */
      {
        key: 'numeroDocumento',
        name: '#Documento',
        search: false,
        type: 'number',
        width: '100px',
      },
      {
        key: 'alumno',
        name: 'Alumno',
        search: false,
        format: row => (`${row.apellido}, ${row.nombre}`.trim()),
      },
      {
        key: 'fecha',
        name: <span>Inscripci&oacute;n</span>,
        search: false,
        // className: 'text-center',
        format: ({ fechaInscripcion, usuarioInscripcion }) => (
          `${dateDDMMYYFormat(fechaInscripcion)} - ${usuarioInscripcion}`
        ),
      },
      {
        key: 'esRecuperatorio',
        name: 'Instancia',
        search: false,
        className: 'text-center',
        format: ({ id, instancia }) => {
          let color = 'danger';
          if (instancia.value === 1) {
            color = 'info';
          }

          if (instancia.value === 0) {
            color = 'success';
          }

          return (
            <span style={{ display: 'flex', justifyContent: 'center' }}>
              {
                <button key={`${id}_${instancia.value}`} type="button" className="action-button" tabIndex="-1">
                  <TooltipItem
                    id={`instancia_${id}_${instancia.value}`}
                    value={instancia.label}
                    label={instancia.item ? instancia.item.motivo : instancia.label}
                    key={`instancia_${id}_${instancia.value}`}
                    color={color}
                  />
                </button>
              }
            </span>
          );
        },
      },
      {
        key: 'asistenciaMateria',
        name: '% Asis. - PP Materia',
        search: false,
        editable: false,
        className: 'text-center',
        format: ({
          id, esInconsistente, asistenciaMateria, porcentajeAsistencia, ppMateria, porcentajePP,
        }) => {
          const asistencia = esInconsistente ? asistenciaMateria : porcentajeAsistencia;
          const pp = esInconsistente ? ppMateria : porcentajePP;
          return (
            <span style={{ display: 'flex', justifyContent: 'center' }}>
              <button key={`am_${id}_${asistencia}`} type="button" className="action-button" tabIndex="-1">
                <TooltipItem
                  id={`am-tooltip-${id}`}
                  value={`${asistencia}`}
                  label={`${asistencia}`}
                  key={`am_${id}_${asistencia}`}
                  color="secondary"
                />
              </button>
              -
              <button key={`ppm_${id}_${pp}`} type="button" className="action-button" tabIndex="-1">
                <TooltipItem
                  id={`ppm_-tooltip-${id}`}
                  value={`${pp}`}
                  label={`${pp}`}
                  key={`ppm__${id}_${pp}`}
                  color="secondary"
                />
              </button>
            </span>
          );
        },
      },
      {
        key: 'porcentajeAsistencia',
        name: '% Asistencia',
        search: false,
        editable: canEdit,
        className: 'text-center',
        inputStyle: (row, key) => this.inputStyle(row, key),
        type: 'number',
        min: '0',
        max: '100',
      },
      {
        key: 'porcentajePP',
        name: '% PP',
        search: false,
        editable: canEdit,
        className: 'text-center',
        inputStyle: (row, key) => this.inputStyle(row, key),
        type: 'number',
        min: '0',
        max: '100',
      },
      {
        key: 'porcentajePF',
        name: '% PF',
        search: false,
        editable: canEdit,
        className: 'text-center',
        inputStyle: (row, key) => this.inputStyle(row, key),
        type: 'number',
        min: '0',
        max: '100',
      },
      {
        key: 'porcentajePC',
        name: '% PC',
        search: false,
        editable: false,
        className: 'text-center',
        inputStyle: (row, key) => this.inputStyle(row, key),
        type: 'number',
        min: '0',
        max: '100',
        format: ({ id, porcentajePC, calificacion }) => {
          const score = Calificaciones.find(c => c.value === calificacion) || {};
          return (
            <span style={{ display: 'flex', justifyContent: 'center' }}>
              <button key={`pc_${id}_${porcentajePC}`} type="button" className="action-button" tabIndex="-1">
                <TooltipItem
                  id={`pc-tooltip-${id}`}
                  value={`${porcentajePC}`}
                  label={`${porcentajePC}`}
                  key={`pc_${id}_${porcentajePC}`}
                  color={score.color}
                />
              </button>
            </span>
          );
        },
      },
      {
        key: 'calificacion',
        name: <span>Calificaci&oacute;n</span>,
        search: false,
        editable: false,
        type: 'number',
        className: 'text-center',
        inputStyle: () => this.scoreInputStyle,
        min: '0',
        max: '5',
        step: '1',
        format: ({ id, calificacion }) => this.showScore({
          id,
          calificacion: Calificaciones.find(c => c.value === calificacion) || {},
        }),
      },
      {
        key: 'actions',
        name: 'Accion',
        width: '85px',
        visible: addButton && canEdit,
      },
    ];
    this.actions = ({ addButton }) => [
      {
        key: addButton ? 'edit' : '',
        icon: <span className="fa fa-edit" title="Editar nota" />,
        callback: (inscription) => {
          this.editExamInscription(inscription);
        },
      },
      {
        key: addButton ? 'delete' : '',
        icon: <span className="fa fa-trash" title="Borrar nota" />,
        callback: (inscription) => {
          this.deleteExamInscription(inscription);
        },
      },
    ];
  }

  reviewRequestsButton = () => {
    const { currentUser } = this.state;

    const {
      id,
      history,
      cantidadReclamosPendientes,
    } = this.props;

    if (!id || !(currentUser.esAdmin || currentUser.esFuncionario || currentUser.esProfesor)) {
      return null;
    }
    return (
      <button
        type="button"
        className="btn btn-outline-info"
        onClick={() => history.push(`/pages/exams/edit/${id}/review-requests`)}
      >
        <span className="fa fa-comments" title="Gestionar solicitudes de revisión" />
        {' '}
        Gestionar solicitudes de revisión {
          cantidadReclamosPendientes ? (
            <Badge
              color="secondary"
              pill
            >
              {cantidadReclamosPendientes}
            </Badge>
          ) : null
        }
      </button>
    );
  };

  openButton = () => {
    const { currentUser } = this.state;

    if (!currentUser || !currentUser.esAdminRoot) {
      return null;
    }

    const {
      id,
      materia,
      fecha,
      estado,
    } = this.props;

    if (!id || ![EstadoExamen.Sellado.value].includes(estado.value)) {
      return null;
    }

    return (
      <button
        type="submit"
        className="btn btn-outline-warning"
        onClick={() => this.handleOpenExam({
          id,
          materia,
          fecha,
          estado,
        })}
      >
        <span className="fa fa-unlock" title="Abrir examen" />
        {' '}
        Abrir examen
      </button>
    );
  }

  moveSection = () => {
    const { id, history } = this.props;
    history.push(`/pages/exams/edit/${id}/move-inscriptions`);
  };

  showScore = ({ id, calificacion }) => (
    <span style={{ display: 'flex', justifyContent: 'center' }}>
      {
        <button key={`${id}_${calificacion.value}`} type="button" className="action-button" tabIndex="-1">
          <TooltipItem
            id={`${id}_${calificacion.value}`}
            value={calificacion.label}
            label={calificacion.label}
            key={`${id}_${calificacion.value}`}
            color={calificacion.color}
          />
        </button>
      }
    </span>
  );

  autoguardarNota = (row, key, value) => {
    const { inscriptos } = this.state;
    const trow = inscriptos.find(r => r.id === row.id);

    if (!trow) return;
    trow[key] = +value;

    const {
      id: inscripcionId, porcentajeAsistencia, porcentajePC, porcentajePF, porcentajePP, calificacion,
    } = {
      ...row,
      [key]: +value,
    };

    const { handleActualizarNotasProfesor } = this.props;

    handleActualizarNotasProfesor({
      inscripcionId, porcentajeAsistencia, porcentajePC, porcentajePF, porcentajePP, calificacion,
    });
  };

  editExamInscription = (inscription) => {
    if (inscription) {
      const { id, history } = this.props;
      history.push(`/pages/exams/inscription/${id}/${inscription.id}`);
    }
  };

  addExamInscription = () => {
    const { id, history } = this.props;
    history.push(`/pages/exams/inscription/${id}`);
  };

  deleteExamInscription = (inscription) => {
    if (inscription) {
      const { handleDeleteInscription } = this.props;
      handleDeleteInscription(inscription);
    }
  };

  getGridActions = (key) => {
    const { estado = { value: 0 } } = this.props;
    const { currentUser } = this.state;
    const addButton = currentUser.esAdmin || currentUser.esFuncionario;

    const actions = {
      actions: this.actions({ addButton }).filter(a => a.key),
    };

    return estado.value === 0 && actions[key];
  }

  handleShowPreviewRecuperatorioExam = ({ id, estado }) => {
    const { history } = this.props;
    if (estado.value === 1) {
      history.push(`/pages/exams/show-recuperatorio-report/${id}`);
    }
  };

  handleDownloadRespaldoDocente = ({ id, materia }) => {
    const [materiaName] = materia.label
      .replace('(', '-')
      .replace(')', '')
      .split('-')
      .map(it => it.trim());


    this.setState({ loading: true });
    downloadAcademicStatusStudent({ id, materiaName }, {
      onSuccess: () => {
        this.setState({ loading: false });
        createSuccessMessage('Archivo descargado exitosamente');
      },
      onError: (error) => {
        this.setState({ loading: false });
        if (error && error.status === 404) {
          createErrorMessage('El examen no existe');
        } else if (error && error.status === 400) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Error al intentar descargar la planilla de calificaciones del examen');
        }
      },
    });
  }

  handleShowPreviewExam = (examen) => {
    const { history } = this.props;
    const {
      id,
      materia,
      fecha,
      nroActa,
      estado,
    } = examen;

    const style = { dateStyle: 'short' };
    const dateFormated = new Intl.DateTimeFormat('en-GB', style).format(new Date(fecha));
    const [materiaName, carreraName] = materia.label
      .replace('(', '-')
      .replace(')', '')
      .split('-')
      .map(it => it.trim());


    const confirmData = {
      title: `Imprimir Examen ${materiaName} ${carreraName}`,
      noLabel: 'No, Volver',
      color: 'success',
    };

    if (estado.value === 1) {
      const question = (
        <>
          &iquest;{`Imprimir el acta o planilla de calificaciones del examen 
      ${materia.label} del ${dateFormated} Acta N`}&ordm;{` ${nroActa}?`
          }
        </>
      );

      confirmData.question = question;
      confirmData.yesLabel = 'Imprimir Acta';
      confirmData.otherLabel = 'Descargar Acta';

      confirmData.onConfirm = () => {
        history.push(`/pages/exams/show-report/${id}`);
      };
      confirmData.onOther = () => {
        this.setState({ loading: true });
        downloadAcademicStatusStudent({ id: examen.id, materiaName }, {
          onSuccess: () => {
            this.setState({ loading: false });
            createSuccessMessage('Archivo descargado exitosamente');
          },
          onError: (error) => {
            this.setState({ loading: false });
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar descargar la planilla de calificaciones del examen');
            }
          },
        });
      };
    }

    if (estado.value === EstadoExamen.Activo.value) {
      const question = (
        <>
          &iquest;{`Imprimir planilla de calificaciones del examen
      ${materia.label} del ${dateFormated} Acta N`}&ordm;{` ${nroActa}?`
          }
        </>
      );

      confirmData.question = question;
      confirmData.yesLabel = 'Descargar Acta';
      confirmData.onConfirm = () => {
        this.setState({ loading: true });
        downloadAcademicStatusStudent({ id: examen.id, materiaName }, {
          onSuccess: () => {
            this.setState({ loading: false });
            createSuccessMessage('Archivo descargado exitosamente');
          },
          onError: (error) => {
            this.setState({ loading: false });
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar descargar la planilla de calificaciones del examen');
            }
          },
        });
      };
    }

    Confirm(confirmData);
  };

  handleStampExam = (examen) => {
    const {
      materia,
      fecha,
      fechaInicioReclamo: examenFechaInicioReclamo,
      fechaFinReclamo: examenFechaFinReclamo,
    } = examen;

    const {
      fechaInicioReclamo: propFechaInicioReclamo,
      fechaFinReclamo: propFechaFinReclamo,
    } = this.props;

    const fechaInicioReclamo = examenFechaInicioReclamo || propFechaInicioReclamo;
    const fechaFinReclamo = examenFechaFinReclamo || propFechaFinReclamo;

    const materiaLabel = (materia && materia.label) || materia || '';
    const style = { dateStyle: 'short' };
    const dateFormated = new Intl.DateTimeFormat('en-GB', style).format(new Date(fecha));

    Confirm({
      title: 'Sellar examen',
      question: (
        <>
          &iquest;Est&aacute;s seguro que deseas sellar el examen {materiaLabel} del {dateFormated}?
          <div>Una vez sellado no se podr&aacute;n modificar las calificaciones.</div>
        </>
      ),
      yesLabel: 'Si, Sellar examen',
      noLabel: 'No, Volver',
      color: 'primary',
      onConfirm: () => {
        stampExam(examen.id, {
          id: examen.id,
          fechaInicioReclamo,
          fechaFinReclamo,
        }, {
          onSuccess: () => {
            const { history } = this.props;
            history.push('/pages/exams');
            createSuccessMessage('Examen sellado exitosamente');
            history.push(`/pages/exams/edit/${examen.id}`);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar sellar el examen');
            }
          },
        });
      },
    });
  };

  handleStampDateChange = (name, value) => {
    this.setState(prevState => ({
      stampExamData: {
        ...prevState.stampExamData,
        [name]: value,
      },
    }));
  };

  closeStampModal = () => {
    this.setState({ stampModal: false, stampModeProfessor: false });
  };

  handleConfirmExam = (examen) => {
    const {
      materia,
      fecha,
      fechaInicioReclamo,
      fechaFinReclamo,
    } = examen;
    const {
      fechaInicioReclamo: propFechaInicioReclamo,
      fechaFinReclamo: propFechaFinReclamo,
    } = this.props;

    const materiaLabel = (materia && materia.label) || materia || '';
    const style = { dateStyle: 'short' };
    const dateFormated = new Intl.DateTimeFormat('en-GB', style).format(new Date(fecha));

    this.setState({
      stampModal: true,
      stampModeProfessor: true,
      stampExamData: {
        ...examen,
        materia: materiaLabel,
        fecha: dateFormated,
        fechaInicioReclamo: fechaInicioReclamo || propFechaInicioReclamo || '',
        fechaFinReclamo: fechaFinReclamo || propFechaFinReclamo || '',
      },
    });
  };

  confirmNotesExam = () => {
    const { stampExamData } = this.state;
    const {
      fechaInicioReclamo,
      fechaFinReclamo,
    } = stampExamData;

    if (!fechaInicioReclamo || !fechaFinReclamo) {
      createWarningMessage('Debes completar Inicio y Fin de solicitud de revisión antes de confirmar las notas.');
      return;
    }

    if (new Date(fechaInicioReclamo) > new Date(fechaFinReclamo)) {
      createWarningMessage(
        'Rango de solicitud de revisión inválido: la fecha inicio no puede ser mayor a la fecha fin.',
      );
      return;
    }

    confirmExam(stampExamData.id, {
      id: stampExamData.id,
      fechaInicioReclamo,
      fechaFinReclamo,
    }, {
      onSuccess: () => {
        const { history } = this.props;
        this.setState({ stampModal: false, stampModeProfessor: false });
        history.push('/pages/exams');
        createSuccessMessage('Notas confirmadas exitosamente');
        history.push(`/pages/exams/edit/${stampExamData.id}`);
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('El examen no existe');
        } else if (error && error.status === 400) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Error al intentar confirmar las notas');
        }
      },
    });
  };

  printFinalButton = () => {
    const {
      id,
      estado,
      history,
      instanciasExamen = [],
    } = this.props;

    if (!id || [EstadoExamen.Activo.value, EstadoExamen.Inconsistente.value].includes(estado.value)) {
      return null;
    }

    return instanciasExamen.filter(i => i.value === InstanciaExamen.Final)
      .map(i => (
        <button
          type="submit"
          className="btn btn-outline-info"
          onClick={() => history.push(`/pages/exams/show-final-report/${id}`)}
        >
          <span className="fa fa-print" title="Imprimir Acta" />
          {' '}
          Imprimir Acta {i.label}
        </button>
      ));
  }

  printRecuperatorioButton = () => {
    const {
      id,
      estado,
      history,
      instanciasExamen = [],
      inscriptos = [],
    } = this.props;

    if (!id || estado.value !== 1) {
      return null;
    }

    const existsRecuperatorio = inscriptos.some(({ instancia }) => instancia.value === InstanciaExamen.Recuperatorio);
    if (!existsRecuperatorio) {
      return null;
    }

    return instanciasExamen.filter(i => i.value === InstanciaExamen.Recuperatorio)
      .map(i => (
        <button
          type="submit"
          className="btn btn-outline-info"
          onClick={() => history.push(`/pages/exams/show-recuperatorio-report/${id}`)}
        >
          <span className="fa fa-print" title="Imprimir Acta" />
          {' '}
          Imprimir Acta {i.label}
        </button>
      ));
  }

  printAllButton = () => {
    const {
      id,
      history,
    } = this.props;

    if (!id) {
      return null;
    }

    return (
      <button
        type="submit"
        className="btn btn-outline-info"
        onClick={() => history.push(`/pages/exams/show-all-report/${id}`)}
      >
        <span className="fa fa-print" title="Imprimir Lista Inscriptos" />
        {' '}
        Imprimir Lista Inscriptos
      </button>
    );
  }

  moveStudentsButton = () => {
    const { currentUser } = this.state;

    if (!currentUser || !currentUser.esAdminRoot) {
      return null;
    }

    const { id, estado } = this.props;

    if (!id || ![EstadoExamen.Sellado.value].includes(estado.value)) {
      return null;
    }

    return (
      <button
        type="button"
        className="btn btn-outline-warning"
        onClick={this.moveSection}
      >
        <span className="fa fa-share" title="Mover alumnos" />
        {' '}
        Mover alumnos
      </button>
    );
  }

  stumpButton = (addButton) => {
    const {
      id,
      materia,
      fecha,
      estado,
      profesor,
    } = this.props;
    const { currentUser } = this.state;

    // Admin can always confirm; professor only if assigned to the exam.
    const isAssignedProfessor = (
      currentUser
      && currentUser.esProfesor
      && profesor
      // eslint-disable-next-line eqeqeq
      && profesor.value == currentUser.id
    );
    const canConfirmNotes = currentUser && (currentUser.esAdmin || isAssignedProfessor);

    // Confirm button is available when exam is Active or Inconsistent
    const professorAllowedStates = [
      EstadoExamen.Activo.value,
      EstadoExamen.Inconsistente.value,
    ];

    if (id && canConfirmNotes && professorAllowedStates.includes(estado.value)) {
      return (
        <button
          type="submit"
          className="btn btn-outline-primary"
          onClick={() => this.handleConfirmExam({
            id,
            materia,
            fecha,
            estado,
          })}
        >
          <span className="fa fa-check" title="Confirmar notas" />{' '}
          Confirmar notas
        </button>
      );
    }

    // Admins/funcionarios can only sell after professor confirmed (estado = ConfirmarNotas)
    if (addButton && id && estado.value === EstadoExamen.ConfirmarNotas.value) {
      return (
        <button
          type="submit"
          className="btn btn-outline-primary"
          onClick={() => this.handleStampExam({
            id,
            materia,
            fecha,
            estado,
          })}
        >
          <span className="fa fa-lock" title="Sellar examen" />{' '}
          Sellar examen
        </button>
      );
    }

    return null;
  }

  descargarRespaldoDocenteButton = () => {
    const { id, materia = {} } = this.props;

    if (!id) {
      return null;
    }

    return (
      <button
        type="submit"
        className="btn btn-outline-info"
        onClick={() => this.handleDownloadRespaldoDocente({ id, materia })}
      >
        <span className="fa fa-print" title="Descargar Respaldo Docente" />{' '}
        Descargar Respaldo Docente
      </button>
    );
  }

  getLabelEstados = () => (
    <Row dir="ltr" style={{ marginBottom: '1rem' }}>
      <Col sm={12}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <h4 style={{ textAlign: 'end' }}>Estados:</h4>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="secondary"
            pill
          >
            Activo expirado
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="info"
            pill
          >
            Activo
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="success"
            pill
          >
            Sellado
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="danger"
            pill
          >
            Inconsistencia de datos
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="warning"
            pill
          >
            Confirmar Notas
          </Badge>
        </div>
      </Col>
    </Row>
  );

  handleOpenExam(examen) {
    const {
      materia,
      fecha,
    } = examen;

    const style = { dateStyle: 'short' };
    const dateFormated = new Intl.DateTimeFormat('en-GB', style).format(new Date(fecha));

    Confirm({
      title: 'Abrir examen',
      question: (
        <>
          &iquest;Est&aacute;s seguro que deseas abrir el examen {materia.label} del {dateFormated}?
          <div>Esto permitir&aacute; editar las calificaciones.</div>
        </>
      ),
      yesLabel: 'Si, Abrir examen',
      noLabel: 'No, Volver',
      color: 'success',
      onConfirm: () => {
        openExam(examen.id, examen, {
          onSuccess: () => {
            const { history } = this.props;
            history.push('/pages/exams');
            createSuccessMessage('Examen abierto exitosamente');
            history.push(`/pages/exams/edit/${examen.id}`);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar abrir el examen');
            }
          },
        });
      },
    });
  }

  render() {
    const {
      currentUser,
      loading,
      stampModal,
      stampModeProfessor,
      stampExamData,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    const {
      id,
      submitting,
      handleSubmit,
      onBack,
      profesores = [],
      materias,
      carreras,
      onFilterChanges,
      onSubjectChanges,
      handleChangeText,
      periodosLectivos,
      periodosExamen,
      estado,
      nroActa,
      notasObservaciones,
      fecha,
      fechaLimiteInscripcion,
      fechaInicioReclamo,
      fechaFinReclamo,
      carrera = {},
      periodo = {},
      periodoLectivo = {},
      materia = {},
      interventor = {},
      interventorAuxiliar = {},
      profesor = {},
      inscriptos,
    } = this.props;

    const addButton = currentUser.esAdmin || currentUser.esFuncionario;

    const canEdit = estado.value === 0 && addButton;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <Col md={12} lx={12}>
                <div className="card__title">
                  <h5 className="bold-text">Datos del examen</h5>
                </div>
              </Col>
              <Col lg={4} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Carrera</span>
                  <div className="form__form-group-field">
                    {
                      canEdit
                        ? (
                          <Field
                            name="carrera"
                            component={renderSelectField}
                            placeholder="Carrera"
                            autoComplete="false"
                            options={carreras}
                            onChange={v => onFilterChanges('carrera', 'carreraId', v)}
                          />
                        )
                        : <input name="carrera" type="text" value={carrera.label} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Periodo Lectivo</span>
                  <div className="form__form-group-field">
                    {canEdit
                      ? (
                        <Field
                          name="periodoLectivo"
                          component={renderSelectField}
                          placeholder="Periodo Lectivo"
                          autoComplete="false"
                          options={periodosLectivos}
                          onChange={v => onFilterChanges('periodoLectivo', 'periodoLectivoId', v)}
                        />
                      )
                      : <input name="periodoLectivo" type="text" value={periodoLectivo.label} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Materia</span>
                  <div className="form__form-group-field">
                    {canEdit
                      ? (
                        <Field
                          name="materia"
                          component={renderSelectField}
                          placeholder="Materia"
                          autoComplete="false"
                          options={materias}
                          onChange={v => onSubjectChanges('materia', 'materiaPeriodoId', v)}
                        />
                      )
                      : <input name="materia" type="text" value={materia.label} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Interventor 1</span>
                  <div className="form__form-group-field">
                    {canEdit
                      ? (
                        <Field
                          name="interventor"
                          component={renderSelectField}
                          placeholder="Interventor 1"
                          autoComplete="false"
                          options={profesores}
                        />
                      )
                      : <input name="interventor" type="text" value={interventor.label} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Profesor a cargo</span>
                  <div className="form__form-group-field">
                    {canEdit
                      ? (
                        <Field
                          name="profesor"
                          component={renderSelectField}
                          placeholder="Profesor a cargo"
                          autoComplete="false"
                          options={profesores}
                          onChange={v => onFilterChanges('profesor', 'profesorId', v)}
                        />
                      )
                      : <input name="interventor" type="text" value={profesor.label} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Interventor 2</span>
                  <div className="form__form-group-field">
                    {canEdit
                      ? (
                        <Field
                          name="interventorAuxiliar"
                          component={renderSelectField}
                          placeholder="Interventor 2"
                          autoComplete="false"
                          options={profesores}
                        />
                      )
                      : <input name="interventorAuxiliar" type="text" value={interventorAuxiliar.label} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} lx={12}>

                <div className="form__form-group">
                  <span className="form__form-group-label">Inicio reclamo</span>
                  <div className="form__form-group-field">
                    <input
                      name="fechaInicioReclamo"
                      type="text"
                      value={fechaInicioReclamo ? dateFormat(fechaInicioReclamo) : ''}
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} lx={12}>

                <div className="form__form-group">
                  <span className="form__form-group-label">Fin reclamo</span>
                  <div className="form__form-group-field">
                    <input
                      name="fechaFinReclamo"
                      type="text"
                      value={fechaFinReclamo ? dateFormat(fechaFinReclamo) : ''}
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} lx={12}>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Fecha de examen</span>
                  <div className="form__form-group-field">
                    {
                      canEdit
                        ? (
                          <Field
                            name="fecha"
                            component={TextBox}
                            placeholder="Fecha de examen"
                            autoComplete="false"
                            type={canEdit ? 'datetime-local' : 'text'}
                            disabled={!canEdit}
                            format={value => (canEdit ? value : this.format(value))}
                            onBlur={({ target }) => handleChangeText({ target })}
                          />

                        )
                        : <input name="fecha" type="text" value={dateFormat(fecha)} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} lx={12}>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Fecha L&iacute;mite Inscripci&oacute;n</span>
                  <div className="form__form-group-field">
                    {
                      canEdit
                        ? (
                          <Field
                            name="fechaLimiteInscripcion"
                            component={TextBox}
                            placeholder="Fecha L&iacute;mite Inscripci&oacute;n"
                            autoComplete="false"
                            type={canEdit ? 'datetime-local' : 'text'}
                            disabled={!canEdit}
                            format={value => (canEdit ? value : this.format(value))}
                            onBlur={({ target }) => handleChangeText({ target })}
                          />
                        )
                        : (
                          <input
                            name="fechaLimiteInscripcion"
                            type="text"
                            value={dateFormat(fechaLimiteInscripcion)}
                            disabled
                          />
                        )
                    }
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Periodo del examen</span>
                  <div className="form__form-group-field">
                    {
                      canEdit
                        ? (
                          <Field
                            name="periodo"
                            component={renderSelectField}
                            placeholder="Periodo del examen"
                            autoComplete="false"
                            options={periodosExamen}
                          />
                        )
                        : <input name="periodo" type="text" value={periodo.label} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">N&uacute;mero de acta</span>
                  <div className="form__form-group-field">
                    {
                      canEdit
                        ? (
                          <Field
                            name="nroActa"
                            component={TextBox}
                            type="text"
                            maxLength={128}
                            placeholder="N&uacute;mero de acta"
                            autoComplete="false"
                          />
                        )
                        : <input name="nroActa" type="text" value={nroActa} disabled />
                    }
                  </div>
                </div>
              </Col>
              <Col lg={6} md={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Notas / Observaciones</span>
                  <div className="form__form-group-field">
                    {
                      canEdit
                        ? (
                          <Field
                            name="notasObservaciones"
                            component={TextBox}
                            type="textarea"
                            maxLength={2048}
                            placeholder="Notas / Observaciones"
                            autoComplete="false"
                          />
                        )
                        : <input name="notasObservaciones" type="text" value={notasObservaciones} disabled />
                    }
                  </div>
                </div>
              </Col>
            </Form>
            <div className="">
              {canEdit && (
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitting}
                  onClick={handleSubmit}
                >Guardar
                </button>
              )}
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
              {this.stumpButton(addButton)}
              {this.openButton()}
              {this.printFinalButton()}
              {this.printRecuperatorioButton()}
              {this.descargarRespaldoDocenteButton()}
              {this.printAllButton()}
              {this.moveStudentsButton()}
              {this.reviewRequestsButton()}
            </div>

            <ModalForm
              header
              buttonToolbar
              colored={false}
              color="primary"
              title={stampModeProfessor ? 'Confirmar notas' : 'Sellar examen'}
              isOpen={stampModal}
              toggle={this.closeStampModal}
              onOk={stampModeProfessor ? this.confirmNotesExam : this.confirmStampExam}
              onCancel={this.closeStampModal}
              okButtonText={stampModeProfessor ? 'Si, Confirmar notas' : 'Si, Sellar examen'}
              cancelButtonText="No, Volver"
              size="lg"
            >
              <StampExamForm
                materia={stampExamData.materia}
                fecha={stampExamData.fecha}
                fechaInicioReclamo={stampExamData.fechaInicioReclamo}
                fechaFinReclamo={stampExamData.fechaFinReclamo}
                onChange={this.handleStampDateChange}
                mode={stampModeProfessor ? 'confirmGrades' : 'stamp'}
              />
            </ModalForm>

            <hr />
            {id && (
              <div className="table-wrapper">
                {canEdit && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.addExamInscription()}
                    >
                      <i className="fa fa-check-square-o fa-lg" /> Agregar/Quitar Alumnos
                    </button>
                  </>
                )}
                <DataTable
                  title="Detalle de alumnos inscriptos y notas"
                  columns={this.columns({
                    canEdit: estado.value === 0,
                    addButton,
                  })}
                  items={inscriptos}
                  page={1}
                  pageSize={1000}
                  totalItemsCount={0}
                  getGridActions={key => this.getGridActions(key)}
                  onAutoSave={this.autoguardarNota}
                  initialValues={{}}
                  enableReinitialize
                />
              </div>
            )}
            <div className="card__title">
              {canEdit && (
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitting}
                  onClick={handleSubmit}
                >Guardar
                </button>
              )}
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxExamForm = reduxForm({
  form: 'ExamForm',
  validate,
  enableReinitialize: true,
})(ExamForm);

export default setPropsAsInitialValues(ReduxExamForm);
